const KEY = "cl_chat_mute";
let ctx = null;

export const isMuted = () => localStorage.getItem(KEY) === "1";
export const setMuted = (v) => { localStorage.setItem(KEY, v ? "1" : "0"); window.dispatchEvent(new Event("cl-chat-mute")); };

export const chime = (volume = 1) => {
  if (isMuted()) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    [[880, 0], [1318.5, 0.12]].forEach(([f, t]) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = "sine"; o.frequency.value = f;
      g.gain.setValueAtTime(0, now + t);
      g.gain.linearRampToValueAtTime(0.18 * volume, now + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.45);
      o.connect(g).connect(ctx.destination); o.start(now + t); o.stop(now + t + 0.5);
    });
  } catch { /* audio not available */ }
};
